import { useMemo } from 'react';
import { useDebouncedBuilderValues } from '~/hooks/document-builder/useDebouncedBuilderValues';
import { draftTotals } from '~/utils/invoicing';

export const useValuesTotals = () => {
  const values = useDebouncedBuilderValues();
  return useMemo(() => draftTotals(values), [values]);
};
